// ----------------------------------------------------------------------------
// Template: Index
// ----------------------------------------------------------------------------
// Home Page Template
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/headline-block/headline-block';
import 'sections/hero-banner/hero-banner';
import 'sections/hero-countdown/hero-countdown';
import 'sections/intro-block/intro-block';
import 'sections/sliding-tiles/sliding-tiles';
import 'sections/collection-list/collection-list';
import 'sections/banner/banner-block';
import 'sections/icon-block/icon-block';
import 'sections/content-panel/content-panel';
import 'sections/faqs/faqs';
import 'sections/testimonial/testimonial';
import 'sections/featured-collection/featured-collection';
import 'sections/blog-posts/blog-posts';
import 'sections/newsletter/newsletter';
import 'sections/footer/footer';

// Styles
